import { render, staticRenderFns } from "./BoxContentMessageLayout.vue?vue&type=template&id=c7734bf4&scoped=true&"
import script from "./BoxContentMessageLayout.vue?vue&type=script&lang=js&"
export * from "./BoxContentMessageLayout.vue?vue&type=script&lang=js&"
import style0 from "./BoxContentMessageLayout.vue?vue&type=style&index=0&id=c7734bf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7734bf4",
  null
  
)

export default component.exports